module.exports = __webpack_public_path__ + "media/preview/workshop@3x-a5ab24ea.png";